import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React from 'react';
import cx from 'classnames';
import { GENERAL_CASHBACK_202505_GA_TAGS } from 'src/constants';
import LinearCTAButton from 'src/components/LinearCTAButton';
import EditorPicksHome from 'src/components/EditorPicksHome/EditorPicksHome';

import AppleBannerImg from './assets/apple-banner-v2.png';
import AmazonImg from './assets/merchants/amazon.png';
import AgodaImg from './assets/merchants/agoda.png';
import BRedImg from './assets/merchants/b-red.png';
import BuymaImg from './assets/merchants/buyma.png';
import DmmImg from './assets/merchants/dmm.png';
import MoreContactImg from './assets/merchants/more-contact.png';
import Qoo10Img from './assets/merchants/qoo10.png';
import RakutenImg from './assets/merchants/rakuten.png';
import SheinImg from './assets/merchants/shein.png';
import ShoplistImg from './assets/merchants/shoplist.png';
import TemuImg from './assets/merchants/temu.png';
import WillerImg from './assets/merchants/willer.png';
import styles from './SectionMerchants.module.scss';

const MERCHANTS = [
  { key: 'Amazon', img: AmazonImg },
  { key: 'SHEIN', img: SheinImg },
  { key: 'Qoo10', img: Qoo10Img },
  { key: 'TEMU', img: TemuImg },
  { key: 'DMM', img: DmmImg },
  { key: 'BUYMA', img: BuymaImg },
  { key: 'Agoda', img: AgodaImg },
  { key: 'Rakuten', img: RakutenImg },
  { key: 'SHOPLIST', img: ShoplistImg },
  { key: 'B-RED', img: BRedImg },
  { key: 'MoreContact', img: MoreContactImg },
  { key: 'WILLER', img: WillerImg },
];

export default function SectionMerchant({ id, editorItems }) {
  return (
    <section id={id || 'merchant-section'} className={styles.section}>
      <h2 className={styles.text}>使えるお店</h2>
      <h3 className={styles.heading}>
        AmazonやQoo10など
        <br />
        70万店以上で使える
      </h3>
      <div className={styles.merchants}>
        {MERCHANTS.map((merchant) => (
          <img
            key={merchant.key}
            alt={merchant.key}
            src={merchant.img}
            width={151}
            height={47}
          />
        ))}
      </div>

      {editorItems && editorItems.length > 0 && (
        <EditorPicksHome
          items={editorItems}
          style={{ backgroundColor: '#fafafa', padding: '64px 16px' }}
          className={styles.editorPicksWrapper}
        />
      )}

      <LinearCTAButton
        text="使えるお店をチェック"
        to="/shop"
        isExternal
        className={styles.shopButton}
      />
      <OutboundLink
        href="/apple"
        target="_blank"
        rel="noreferrer"
        className={cx(styles.appleBanner, GENERAL_CASHBACK_202505_GA_TAGS.PPFA)}
      >
        <div className={styles.bannerContainer}>
          <img
            alt="apple-banner"
            src={AppleBannerImg}
            width={343}
            height={224}
          />
          <p className={styles.bannerText}>
            {
              '※その他の取引条件については、当社ホームページの各種利用規約をご確認ください。'
            }
          </p>
        </div>
      </OutboundLink>
    </section>
  );
}
